import { render, staticRenderFns } from "./wait-enter-list.vue?vue&type=template&id=c0eda470&scoped=true&"
import script from "./wait-enter-list.vue?vue&type=script&lang=js&"
export * from "./wait-enter-list.vue?vue&type=script&lang=js&"
import style0 from "./wait-enter-list.vue?vue&type=style&index=0&id=c0eda470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eda470",
  null
  
)

export default component.exports